export class OnboardRdsCdcRequest {
    'replicatorPassword';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "replicatorPassword",
            "baseName": "replicatorPassword",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OnboardRdsCdcRequest.attributeTypeMap;
    }
    constructor() {
    }
}
